import Vue from 'vue'

import Router from 'vue-router'

import routes from './routes'

import store from '@/store'

import services from '@/services'

Vue.use(Router)

const isProduction = process.env.NODE_ENV === 'production'

const basePath = process.env.BASE_PATH

const router = new Router({
  routes: routes,
  base: isProduction ? (basePath || '/embed').replace(/\/$/, '') : '/',
  mode: isProduction ? 'abstract' : 'history'
})

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  if (store.getters.user || to.name === 'login') {
    next()
  } else {
    next({
      path: '/login',
      query: to.query
    })
  }
})

// eslint-disable-next-line
router.afterEach((to, from) => {
  services.iframe.changeIFrameClasses()
})

export default router
